<template>
  <v-form ref="emergency-form" v-model="formValid" class="col-12 d-flex flex-wrap py-0">
    <div class="col-12 d-flex">
      <div class="col-6 py-1">
        <v-text-field
          v-model="newContent.emergency_contacts[index].firstname"
          v-bind="emergencyContactsFieldsProperties('firstname')"
        />
      </div>

      <div class="col-6 py-1">
        <v-text-field
          v-model="newContent.emergency_contacts[index].lastname"
          v-bind="emergencyContactsFieldsProperties('lastname')"
        />
      </div>
    </div>

    <div class="col-12 d-flex">
      <div class="col-6 py-1">
        <v-text-field
          v-model="newContent.emergency_contacts[index].email"
          v-bind="emergencyContactsFieldsProperties('email')"
        />
      </div>

      <div class="col-6 py-1">
        <PhoneNumberField
          v-model="newContent.emergency_contacts[index].telephone"
          :field="emergencyContactsFieldsProperties('telephone')"
        />
      </div>
    </div>
  </v-form>
</template>

<script>
import PhoneNumberField from './PhoneNumberField.vue';
import { emergencyContactsFieldsProperties } from '../../configs/forms';

export default {
  name: 'EmergencyContactsForm',
  components: { PhoneNumberField },
  props: {
    index: {
      type: Number,
      default: 0
    },
    content: {
      type: Object,
      default: () => {}
    },
    valid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      newContent: this.$props.content,
      formValid: this.$props.valid
    };
  },
  watch: {
    formValid (val) { // Updates prop via event
      this.$emit('update:valid', val);
    }
  },
  methods: {
    emergencyContactsFieldsProperties: emergencyContactsFieldsProperties,
    validate () {
      this.$refs[`emergency-form`].validate();
    },
    reset () {
      this.$refs[`emergency-form`].reset();
    },
    resetValidation () {
      this.$refs[`emergency-form`].resetValidation();
    }

  }
};
</script>

<style >
</style>
